import { render, staticRenderFns } from "./washDetails.vue?vue&type=template&id=d0841f22&scoped=true&"
import script from "./washDetails.vue?vue&type=script&lang=js&"
export * from "./washDetails.vue?vue&type=script&lang=js&"
import style0 from "./washDetails.vue?vue&type=style&index=0&id=d0841f22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0841f22",
  null
  
)

export default component.exports